<template>
  <div>
    <Header></Header>
      <div class="col-12 d-inline-flex">
        <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} Stripe Configuration</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label v-if="field.name !== 'stripeConfigurationId' || editMode" :for="field.name">{{ field.label }}:</label>
              <input v-if="(field.name !== 'active' && field.name !== 'status' && field.name !== 'stripeConfigurationId' && field.name !== 'application' && field.name !== 'percentage') || (field.name === 'stripeConfigurationId' && editMode)"
                  :id="field.name" v-model="editedConfig[field.name]" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                  type="text" class="form-control responsive-input" :disabled="(field.name === 'stripeName' || field.name === 'stripeConfigurationId') && editMode">
              <select v-else-if="field.name === 'application'" :id="field.name" v-model="editedConfig[field.name]" class="form-select" style="max-width: 500px;">
                <option v-for="app in applicationList" :key="app" :value="app">{{ app }}</option>
              </select>
              <input v-else-if="field.name === 'percentage'" :id="field.name" :value="editedConfig.percentage + '%'"
                  type="text" class="form-control responsive-input" style="min-width: 120px;" disabled>
              <input class="checkbox" v-else-if="field.name === 'active' || field.name === 'status'" type="checkbox" :id="field.name" v-model="editedConfig[field.name]" disabled>
            </div>

            <p class="text-muted">
              Percentage, Active and Status are read-only here — they're managed on the
              <router-link :to="{ name: 'PaymentManagement' }">Payment Management</router-link> page and
              the backend ignores these fields when saving from this form.
            </p>

            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">{{ editMode ? 'Save Changes' : 'Create Stripe Configuration' }}</a>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {StripeConfig} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'Analytics',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        stripeConfigurationId: this.$route.params.id,
        stripeName: this.$route.params.stripeName,
        privateKey: this.$route.params.privateKey,
        apiKey: this.$route.params.apiKey,
        endpointSecret: this.$route.params.endpointSecret,
        checkoutDomain: this.$route.params.checkoutDomain,
        customerPortalLink: this.$route.params.customerPortalLink,
        application : this.$route.params.application,
        percentage: Number(this.$route.params.percentage) || 0,
        active: (this.$route.params.active === 'true'),
        status: (this.$route.params.status === 'true')
      },
      editMode: false,
      applicationList: [],
      fields: [
        { name: "stripeConfigurationId", label: "Stripe Configuration Id" },
        { name: "stripeName", label: "Stripe Name" },
        { name: "privateKey", label: "Private Key" },
        { name: "apiKey", label: "API Key" },
        { name: "endpointSecret", label: "Endpoint Secret" },
        { name: "checkoutDomain", label: "Checkout Domain" },
        { name: "customerPortalLink", label: "Customer Portal Link" },
        { name: "application", label: "Application" },
        { name: "percentage", label: "Percentage" },
        { name: "active", label: "Active" },
        { name: "status", label: "Status" }
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.id) {
      this.editMode = true;
    }
    const storedApps = localStorage.getItem('applicationList');
    if (storedApps) {
      this.applicationList = JSON.parse(storedApps);
    } else {
      AdminService.getApplications().then(() => {
        this.applicationList = JSON.parse(localStorage.getItem('applicationList'));
      });
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new StripeConfig(
          this.editedConfig.stripeConfigurationId,
          this.editedConfig.stripeName,
          this.editedConfig.privateKey,
          this.editedConfig.apiKey,
          this.editedConfig.endpointSecret,
          this.editedConfig.checkoutDomain,
          this.editedConfig.customerPortalLink,
          this.editedConfig.application ,
          this.editedConfig.percentage,
          this.editedConfig.active,
          this.editedConfig.status
      );

      if (this.editMode) {
        // Editing an existing configuration
        AdminService.updateStripeConfiguration(dataToSave).then(() => {
          alert('Insert complete');

          // Redirect to the /stripe page
          this.$router.push({ name: 'StripeConfig' });
        }).catch((error) => {
          console.error("Error updating Stripe configuration:", error);
          if (error.response && error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      } else {
        AdminService.insertStripeConfiguration(dataToSave).then(() => {
         alert('Insert complete');

          // Redirect to the /stripe page
          this.$router.push({ name: 'StripeConfig' });
        }).catch((error) => {
          this.error = error.message
        });
      }
    }

  }
})
</script>
<style src="../../assets/style.css">
</style>